import React, { FC } from "react";
import { Col, Row } from "antd";
import { IBankForAdd } from "../../../../../store/slice/requestAppSlise/requestAppSlise";

interface IBankListInApplicationInfo {
  preferedBanks?: IBankForAdd[];
}
export const BankListInApplicationInfo: FC<IBankListInApplicationInfo> = ({
  preferedBanks,
}) => {
  return (
    <Row gutter={[16, 16]}>
      {preferedBanks?.map((bank) => (
        <Col key={bank.id} xs={24} sm={24} md={12} lg={8} xl={8}>
          <div>{bank.title}</div>
        </Col>
      ))}
    </Row>
  );
};
